import React, { memo } from 'react';

import { areEqual } from 'Utils/equalityChecks';
import { useSupportPanel } from 'Context/Support';

import { ConversationList } from '../ConversationList/ConversationList';
import { ConversationChat } from '../ConversationChat/ConversationChat';
import { NewConversation } from '../NewConversation/NewConversation';

import classes from './supportPanel.module.css';

function SupportPanel() {
  const { isOpen, closePanel, view, goBack } = useSupportPanel();

  const showBack = view !== 'list';

  const title = view === 'list' ? 'Support' : view === 'new' ? 'New Conversation' : 'Conversation';

  return (
    <>
      <div
        className={`${classes.backdrop} ${isOpen ? classes.backdropOpen : ''}`}
        onClick={closePanel}
        role="presentation"
      />
      <div className={`${classes.panel} ${isOpen ? classes.panelOpen : ''}`}>
        <div className={classes.header}>
          {showBack && (
            <button type="button" className={classes.backButton} onClick={goBack} aria-label="Back">
              &#8592;
            </button>
          )}
          <h2 className={classes.headerTitle}>{title}</h2>
          <button type="button" className={classes.closeButton} onClick={closePanel} aria-label="Close">
            &times;
          </button>
        </div>
        <div className={classes.content}>
          {view === 'list' && <ConversationList />}
          {view === 'chat' && <ConversationChat />}
          {view === 'new' && <NewConversation />}
        </div>
      </div>
    </>
  );
}

const SupportPanelMemo = memo(SupportPanel, areEqual);

export { SupportPanelMemo as SupportPanel };
